export default __webpack_public_path__ + "static/saaS-casestudy-1-a99149ce9c3b5aadd61ff57678825eed.png";